import React, { useContext, MouseEventHandler, useCallback } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import NavigationContextMenuItem, { ExternalNavigationContextMenuItemProps } from './NavigationContextMenuItem';
import NavigationContextMenuContext from './NavigationContextMenuContext';
import ExternalLink from '@/components/navigation/ExternalLink';
import { ExternalLinkButtonProps } from '@/components/Buttons';

type NavigationContextMenuInternalLinkItemProps = ExternalNavigationContextMenuItemProps &
    Pick<ExternalLinkButtonProps, 'href' | 'target'> & {
        icon?: IconProp;
    };

const NavigationContextMenuExternalLinkItem: React.FC<NavigationContextMenuInternalLinkItemProps> = ({
    title,
    subtitle,
    icon,
    imageElement,
    children,
    disabled,
    href,
    target,
}) => {
    const itemProp: ExternalNavigationContextMenuItemProps = {
        title,
        subtitle,
        icon,
        imageElement,
    };

    const context = useContext(NavigationContextMenuContext);

    const handleClick: MouseEventHandler<any> = useCallback(
        (e) => {
            if (disabled) {
                e.preventDefault();
                return;
            }

            context.toggle(false);
        },
        [context, disabled]
    );

    return (
        <NavigationContextMenuItem
            clickable
            disabled={disabled}
            {...itemProp}
            wrapper={
                <ExternalLink onClick={handleClick} href={href} target={target} tabIndex={context.open ? undefined : -1} />
            }>
            {children}
        </NavigationContextMenuItem>
    );
};

export default NavigationContextMenuExternalLinkItem;
